var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { ChevronLink, Box, useResponsiveProp } from '@telus-uds/components-web';
import { ChevronDown, ChevronUp } from '@telus-uds/palette-koodo/build/web/icons';
import _get from 'lodash/get';
import styled from 'styled-components';
import { mediaQueries } from '../../constants/breakpoints';
export var ViewMore = function (_a) {
    var children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, height = _a.height, viewMoreLabel = _a.viewMoreLabel, viewLessLabel = _a.viewLessLabel, _b = _a.align, align = _b === void 0 ? 'start' : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, variant = _a.variant, underline = _a.underline, analytics = _a.analytics;
    var _d = useState(true), showViewMore = _d[0], setShowViewMore = _d[1];
    var _e = useState(0), scrollHeight = _e[0], setScrollHeight = _e[1];
    var _f = useState(false), isExpanded = _f[0], setIsExpanded = _f[1];
    var inputRef = useRef(null);
    var responsiveHeight = useResponsiveProp({ xs: xs, sm: sm, md: md, lg: lg, xl: xl }) || height;
    var _g = analytics !== null && analytics !== void 0 ? analytics : {}, eventActionTrigger = _g.eventActionTrigger, details = _g.details, name = _g.name;
    var contentStyles = perBreakpointHeight({
        height: height,
        scrollHeight: scrollHeight,
        isExpanded: isExpanded,
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl
    });
    var getAnalyticsData = function () {
        return {
            name: "KM_".concat(name === null || name === void 0 ? void 0 : name.pageName, "_FAQ_ViewMore_").concat(name === null || name === void 0 ? void 0 : name.suffix),
            action: 'click',
            details: details
        };
    };
    useEffect(function () {
        if (inputRef) {
            var expandedHeight = _get(inputRef, 'current.scrollHeight', 0);
            setScrollHeight(expandedHeight);
            setShowViewMore(!!responsiveHeight && !!expandedHeight && expandedHeight > responsiveHeight);
        }
    }, [inputRef, responsiveHeight]);
    var onChangeHandler = function () {
        setIsExpanded(!isExpanded);
        onChange(!isExpanded);
        // fire analytic when it is expanding
        if (!isExpanded) {
            var analyticsData = getAnalyticsData();
            analyticsData && (eventActionTrigger === null || eventActionTrigger === void 0 ? void 0 : eventActionTrigger(analyticsData));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(StyledContents, { contentStyles: contentStyles, ref: inputRef, children: children }), showViewMore && (_jsx(Box, { top: 2, children: _jsx(ChevronLink, { href: null, onPressOut: onChangeHandler, variant: variant, tokens: {
                        alignSelf: align,
                        rightIcon: isExpanded ? ChevronUp : ChevronDown,
                        iconDisplace: 0,
                        textLine: underline ? 'underline' : 'none'
                    }, children: isExpanded ? viewLessLabel : viewMoreLabel }) }))] }));
};
var maxHeight = function (_a) {
    var height = _a.height, scrollHeight = _a.scrollHeight, isExpanded = _a.isExpanded;
    return isExpanded ? "".concat(scrollHeight, "px") : "".concat(height !== null && height !== void 0 ? height : scrollHeight, "px");
};
var maskImage = function (_a) {
    var isExpanded = _a.isExpanded, scrollHeight = _a.scrollHeight, height = _a.height;
    return isExpanded || (!!scrollHeight && !!height && scrollHeight <= height)
        ? 'none'
        : 'linear-gradient(180deg, #000 60%, transparent)';
};
var getHeightForBreakpoint = function (props, breakpoint) {
    var _a;
    return (_a = props[breakpoint]) !== null && _a !== void 0 ? _a : props.height;
};
var perBreakpointHeight = function (props) {
    return Object.keys(mediaQueries).map(function (bp) {
        var heightProps = __assign(__assign({}, props), { height: getHeightForBreakpoint(props, bp) });
        return "\n      @media (".concat(mediaQueries[bp], ") {\n        max-height: ").concat(maxHeight(heightProps), ";\n        mask-image: ").concat(maskImage(heightProps), ";\n      }\n    ");
    });
};
var StyledContents = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  transition: 0.4s max-height;\n\n  ", ";\n"], ["\n  overflow: hidden;\n  transition: 0.4s max-height;\n\n  ", ";\n"])), function (_a) {
    var contentStyles = _a.contentStyles;
    return contentStyles;
});
var templateObject_1;
